import { BuildingFilterParameters, getBuildings } from '../../api/buildings';
import { Building } from '../../interfaces/api/building';

export async function fetchBuildings(params: BuildingFilterParameters): Promise<Building[]> {
	try {
		return await getBuildings(params);
	} catch (error) {
		throw error;
	}
}
